module.exports = __webpack_public_path__ + "9ac94853f67cf36e6aaad9ed4c971cb8.svg";